export default [
  {
    type: 'selection',
    width: 55,
    show: true,
  },
  {
    title: '编号',
    key: 'id',
    minWidth: 40,
    maxWidth: 100,
    show: true,
  },
  {
    title: '名称',
    key: 'name',
    slot: 'name',
    show: true,
  },
  {
    title: '支付方式',
    key: 'payment_method',
    slot: 'payment_method',
    show: true,
  },
  {
    title: '支付网关',
    key: 'payment_gateway',
    slot: 'payment_gateway',
    show: true,
  },
  {
    title: '状态',
    key: 'status',
    slot: 'status',
    show: true,
  },
  {
    title: '操作',
    key: 'action',
    slot: 'action',
    width: 120,
    align: 'center',
    fixed: 'right',
    show: true,
  },
]
